"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _classnames = _interopRequireDefault(require("classnames"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _Selectors = require("../constants/Selectors");

var _UIControlledPopover = _interopRequireDefault(require("./UIControlledPopover"));

var _UITooltipContent = _interopRequireDefault(require("./UITooltipContent"));

var _UITooltipHeader = _interopRequireDefault(require("./UITooltipHeader"));

var _PlacementConstants = require("./PlacementConstants");

var _Hover = require("./utils/Hover");

var _domElement = _interopRequireDefault(require("../utils/propTypes/domElement"));

var _Functions = require("../core/Functions");

var _focusStylesListener = require("../listeners/focusStylesListener");

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var USE_CLASSES = {
  default: 'tooltip-default private-tooltip--default',
  danger: 'tooltip-danger private-tooltip--danger',
  longform: 'private-tooltip--longform'
};
var instanceCount = 0;
var allTooltips = [];

var isDisabled = function isDisabled(props) {
  return props.disabled || props.Content == null && !props.title;
};

var isOpen = function isOpen(props) {
  return props.open && !isDisabled(props);
};

var getStyle = function getStyle(style, maxWidth) {
  return (0, _extends2.default)({}, style, {
    maxWidth: maxWidth
  });
};

var getPopoverClassName = function getPopoverClassName(className, use) {
  return (0, _classnames.default)(className, USE_CLASSES[use], 'tooltip', 'private-tooltip');
};

var getPopoverUse = function getPopoverUse(use) {
  if (use === 'default') return 'tooltip';
  if (use === 'danger') return 'tooltip-danger';
  return use;
};

var setOpen = function setOpen(component, newOpen) {
  if (!component._isMounted) return;
  if (newOpen && component.props.disabled) return;
  if (newOpen === component.props.open) return;
  component.props.onOpenChange((0, _SyntheticEvent.default)(newOpen));
};

var getDelayedSetOpen = function getDelayedSetOpen(component, delay) {
  var boundSetOpen = function boundSetOpen() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return setOpen.apply(void 0, [component].concat(args));
  };

  return delay === 0 ? boundSetOpen : function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return setTimeout(function () {
      return boundSetOpen.apply(void 0, args);
    }, delay);
  };
};

var UITooltip =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UITooltip, _PureComponent);

  function UITooltip(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UITooltip);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UITooltip).call(this, props));

    _this.refCallback = function (ref) {
      _this._ref = ref;
    };

    _this.triggerClose = function () {
      var onClose = _this.props.onClose;
      setOpen((0, _assertThisInitialized2.default)(_this), false);
      _this._closeOnPopoverFocusLeave = false;
      (0, _Functions.callIfPossible)(onClose);
    };

    _this.handleKeyDown = function (evt) {
      // Very special-case, but important for a11y: When we tab out of the tooltip
      // target, the focus moves to the first tabbable element inside of the
      // tooltip (if any). When that happens, we need to prevent the tooltip from
      // closing when the target blur event fires and instead close it when the
      // focus leaves the tooltip content.
      var key = evt.key,
          shiftKey = evt.shiftKey;

      if (key === 'Tab' && !shiftKey) {
        var tooltipEl = document.getElementById(_this._tooltipId);

        if (!tooltipEl) {
          return;
        }

        if (tooltipEl.querySelector(_Selectors.FOCUSABLE)) {
          _this._closeOnPopoverFocusLeave = true;
        }
      }
    };

    _this.handleBlur = function () {
      if (_this._closeOnPopoverFocusLeave || !_this._wasOpenedByFocus) {
        return;
      }

      var targetEl = (0, _reactDom.findDOMNode)(_this._ref);

      if (targetEl && targetEl.contains(document.activeElement)) {
        // If blur has occurred but document.activeElement still points to the
        // anchor element, it means the entire document has lost focus. See
        // HubSpot/UIComponents#784
        return;
      }

      _this.triggerClose();
    };

    _this.handleFocus = function () {
      if (!(0, _focusStylesListener.isPageInKeyboardMode)()) return;
      _this._wasOpenedByFocus = true;
      setOpen((0, _assertThisInitialized2.default)(_this), true);
    };

    _this.handlePopoverFocusLeave = function () {
      if (_this._closeOnPopoverFocusLeave) {
        _this.triggerClose();
      }
    };

    _this.handleMouseEnter = function () {
      // Workaround for React bug that allows handleMouseEnter to be called twice
      // for the same event (rare but possible!)
      if (_this._holdTimeout) {
        return;
      }

      var delayOnHold = _this.props.delayOnHold;
      _this._openTimeout = _this._setOpen(true);
      _this._closeOnPopoverFocusLeave = false;
      _this._holdTimeout = setTimeout(function () {
        setOpen((0, _assertThisInitialized2.default)(_this), true);
      }, delayOnHold);
      _this._wasOpenedByFocus = false;

      _this.setState({
        listeningForMouseMove: true
      });
    };

    _this.handleMouseLeave = function () {
      // If open has been triggered but a delay is in effect, cancel open.
      clearTimeout(_this._openTimeout);
      _this._openTimeout = null;
      clearTimeout(_this._holdTimeout);
      _this._holdTimeout = null; // If we're open, we need to keep listening to mousemove until the mouse has left the bounds of
      // the tooltip itself. Otherwise, we don't need the listener.

      _this.setState({
        listeningForMouseMove: isOpen(_this.props)
      });
    };

    _this.handleBodyMouseMove = function (evt) {
      if (!_this._isMounted) return;
      var _this$props = _this.props,
          delayOnHold = _this$props.delayOnHold,
          open = _this$props.open;

      if (open) {
        // Bail early and often if the target and/or tooltip aren't in the DOM
        var targetEl = (0, _reactDom.findDOMNode)(_this._ref);
        if (!targetEl) return;
        var tooltipEl = document.getElementById(_this._tooltipId);
        if (!tooltipEl) return;
        var tooltipArea = tooltipEl.getBoundingClientRect();
        var targetArea = targetEl.getBoundingClientRect();

        if ((0, _Hover.shouldTooltipClose)(targetArea, tooltipArea, evt)) {
          _this.triggerClose();
        }
      } else if (_this._holdTimeout) {
        clearTimeout(_this._holdTimeout);
        _this._holdTimeout = setTimeout(function () {
          setOpen((0, _assertThisInitialized2.default)(_this), true);
        }, delayOnHold);
      }
    };

    _this.renderContent = function () {
      var _this$props2 = _this.props,
          innerClassName = _this$props2.innerClassName,
          headingText = _this$props2.headingText,
          title = _this$props2.title,
          use = _this$props2.use;
      return _react.default.createElement(_UITooltipContent.default, {
        className: (0, _classnames.default)(innerClassName, 'tooltip-inner', {
          'has--vertical-spacing': use === 'longform'
        })
      }, headingText != null ? _react.default.createElement(_UITooltipHeader.default, null, headingText) : null, title);
    };

    _this.state = {
      listeningForMouseMove: false
    };
    _this._hasOpened = false;
    instanceCount += 1;
    _this._tooltipId = "uiTooltip-" + instanceCount;
    _this._getStyle = (0, _memoizeOne.default)(getStyle);
    _this._setOpen = getDelayedSetOpen((0, _assertThisInitialized2.default)(_this), props.delay);
    return _this;
  }

  (0, _createClass2.default)(UITooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      allTooltips.push(this);
      this._isMounted = true;

      if (isOpen(this.props)) {
        this.addBodyMouseListeners();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.delay !== this.props.delay) {
        this._setOpen = getDelayedSetOpen(this, nextProps.delay);
      }

      if (!isOpen(nextProps) && isOpen(this.props)) {
        this.setState({
          listeningForMouseMove: false
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (!isOpen(prevProps) && isOpen(this.props)) {
        this.addBodyMouseListeners();
        allTooltips.forEach(function (tooltip) {
          if (tooltip === _this2) return;

          if (tooltip._isMounted) {
            setOpen(tooltip, false);
          }
        });
      } else if (isOpen(prevProps) && !isOpen(this.props)) {
        this.removeBodyMouseListeners();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      allTooltips.splice(allTooltips.indexOf(this), 1);
      this._isMounted = false;
      this.removeBodyMouseListeners();
    }
  }, {
    key: "addBodyMouseListeners",
    value: function addBodyMouseListeners() {
      if (!document.body) return;
      document.body.addEventListener('mouseleave', this.triggerClose);
      document.body.addEventListener('mousemove', this.handleBodyMouseMove);
    }
  }, {
    key: "removeBodyMouseListeners",
    value: function removeBodyMouseListeners() {
      if (!document.body) return;
      document.body.removeEventListener('mouseleave', this.triggerClose);
      document.body.removeEventListener('mousemove', this.handleBodyMouseMove);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          className = _this$props3.className,
          Content = _this$props3.Content,
          __delay = _this$props3.delay,
          __delayOnHold = _this$props3.delayOnHold,
          __disabled = _this$props3.disabled,
          __headingText = _this$props3.headingText,
          __innerClassName = _this$props3.innerClassName,
          maxWidth = _this$props3.maxWidth,
          __onClose = _this$props3.onClose,
          __open = _this$props3.open,
          style = _this$props3.style,
          __title = _this$props3.title,
          use = _this$props3.use,
          rest = (0, _objectWithoutProperties2.default)(_this$props3, ["children", "className", "Content", "delay", "delayOnHold", "disabled", "headingText", "innerClassName", "maxWidth", "onClose", "open", "style", "title", "use"]);
      var computedDisabled = isDisabled(this.props);
      var computedOpen = isOpen(this.props);

      var child = _react.Children.only(children);

      var clonedChild;

      if (!computedDisabled) {
        var computedDescribedBy = computedOpen ? ((child.props['aria-describedby'] || '') + " " + this._tooltipId).trim() : child.props['aria-describedby'];
        clonedChild = (0, _react.cloneElement)(child, {
          'aria-describedby': computedDescribedBy,
          onBlur: (0, _Functions.memoizedSequence)(this.handleBlur, child.props.onBlur),
          onFocus: (0, _Functions.memoizedSequence)(this.handleFocus, child.props.onFocus),
          onKeyDown: (0, _Functions.memoizedSequence)(this.handleKeyDown, child.props.onKeyDown),
          onMouseEnter: (0, _Functions.memoizedSequence)(this.handleMouseEnter, child.props.onMouseEnter),
          onMouseLeave: (0, _Functions.memoizedSequence)(this.handleMouseLeave, child.props.onMouseLeave),
          tabIndex: 0 // #4949

        });
      } // Perf: Don't generate props for popover if we've never been opened. (They props may still be
      // needed while computedOpen is false if the popover is transitioning.)


      this._hasOpened = this._hasOpened || computedOpen;
      var popoverProps = this._hasOpened ? (0, _extends2.default)({}, rest, {
        arrowSize: use === 'longform' ? 'medium' : 'small',
        className: getPopoverClassName(className, use),
        closeOnTargetLeave: true,
        Content: Content || this.renderContent,
        id: this._tooltipId,
        onFocusLeave: this.handlePopoverFocusLeave,
        open: computedOpen,
        ref: this.refCallback,
        style: this._getStyle(style, maxWidth),
        use: getPopoverUse(use)
      }) : null;
      return _react.default.createElement(_UIControlledPopover.default, popoverProps, clonedChild || child);
    }
  }]);
  return UITooltip;
}(_react.PureComponent);

UITooltip.propTypes = {
  autoPlacement: _UIControlledPopover.default.propTypes.autoPlacement,
  children: _propTypes.default.node,
  Content: _UIControlledPopover.default.propTypes.Content,
  delay: _propTypes.default.number.isRequired,
  delayOnHold: _propTypes.default.number.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  headingText: _propTypes.default.node,
  innerClassName: _propTypes.default.string,
  maxWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  onClose: _propTypes.default.func,
  onOpenChange: _propTypes.default.func.isRequired,
  open: _propTypes.default.bool.isRequired,
  placement: _propTypes.default.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
  title: _propTypes.default.node,
  use: _propTypes.default.oneOf(Object.keys(USE_CLASSES)),
  _bodyElement: _domElement.default
};
UITooltip.defaultProps = {
  autoPlacement: true,
  delay: 300,
  delayOnHold: 100,
  disabled: false,
  open: false,
  placement: 'top',
  use: 'default'
};
UITooltip.displayName = 'UITooltip';

var _default = (0, _Controllable.default)(UITooltip, ['open']);

exports.default = _default;
module.exports = exports.default;